import type * as React from 'react';

function SvgTrash(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <path
        d="M20.2286 4.02532H15.8052C15.8343 3.94532 15.8571 3.86197 15.8571 3.77215V2.75949C15.8571 2.34015 15.5116 2 15.0857 2H8.91429C8.48835 2 8.14286 2.34015 8.14286 2.75949V3.77215C8.14286 3.86197 8.16569 3.94532 8.1948 4.02532H3.77143C3.3455 4.02532 3 4.36547 3 4.78481C3 5.20415 3.3455 5.5443 3.77143 5.5443H4.8V20.9873C4.8 21.5465 5.26008 22 5.82857 22H18.1714C18.7399 22 19.2 21.5465 19.2 20.9873V5.5443H20.2286C20.6545 5.5443 21 5.20415 21 4.78481C21 4.36547 20.6545 4.02532 20.2286 4.02532ZM17.1429 19.9747H6.85714V5.79747H17.1429V19.9747Z"
        fill="currentColor"
      />
      <path
        d="M14.0571 17.6962C14.4831 17.6962 14.8286 17.3561 14.8286 16.9367V8.83544C14.8286 8.4161 14.4831 8.07595 14.0571 8.07595C13.6312 8.07595 13.2857 8.4161 13.2857 8.83544V16.9367C13.2857 17.3561 13.6312 17.6962 14.0571 17.6962Z"
        fill="currentColor"
      />
      <path
        d="M9.94286 17.6962C10.3688 17.6962 10.7143 17.3561 10.7143 16.9367V8.83544C10.7143 8.4161 10.3688 8.07595 9.94286 8.07595C9.51693 8.07595 9.17143 8.4161 9.17143 8.83544V16.9367C9.17143 17.3561 9.51693 17.6962 9.94286 17.6962Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgTrash;
